import { render, staticRenderFns } from "./DataBb.vue?vue&type=template&id=721b9e53&scoped=true&"
import script from "./DataBb.vue?vue&type=script&lang=js&"
export * from "./DataBb.vue?vue&type=script&lang=js&"
import style0 from "./DataBb.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DataBb.vue?vue&type=style&index=1&id=721b9e53&lang=less&scoped=scoped&"
import style2 from "./DataBb.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721b9e53",
  null
  
)

export default component.exports